import { Routes } from '@angular/router';
import { PageNotFoundComponent } from '@modules/public/pages/page-not-found/page-not-found.component';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./modules/public/public.routes'),
  },
  {
    path: '',
    loadChildren: () => import('././modules/authenticated/authenticated.routes'),
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];
